module.exports = {"150523100":"开鲁镇","150523101":"大榆树镇","150523102":"黑龙坝镇","150523103":"麦新镇","150523104":"义和塔拉镇","150523105":"建华镇","150523106":"小街基镇","150523107":"东风镇","150523108":"吉日嘎郎吐镇","150523109":"东来镇","150523400":"清河牧场","150523401":"辽河农场","150523402":"保安农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150523.json
// module id = 385
// module chunks = 0